import React, { useEffect, useRef, useState } from "react";
import roadMapView from "../../../assets/roadMapView.png";
import sateliteView from "../../../assets/sateliteView.png";
import fullScreenIcon from "../../../assets/fullScreenIcon.png";
import collapseIcon from "../../../assets/collapse.png";
import L from "leaflet";
import MarkerIcon from "../../../assets/marker.png";
import { MAP_URLS, STATUS } from "../../../appConstants";
import pilotIcon from "../../../assets/pilot.svg";
import Loading from "../../../ReusableFunctions/Loader";

export default function RequestLocationMap({ lat, lng, status_history }) {

  const [isFullScreen, setIsFullScreen] = useState(false);
  const mapContainerRef = useRef(null);
  const mapRef = useRef(null);
  const [activeBaseLayer, setActiveBaseLayer] = useState("roadmap");

  const markerIcon = L.icon({
    iconUrl: MarkerIcon,
    iconSize: [24, 32],
  });

  const PilotIcon = L.icon({
    iconUrl: pilotIcon,
    iconSize: [30, 36],
  });

  useEffect(() => {
    if (!mapRef.current) {
      mapRef.current = L.map(mapContainerRef.current, {
        center: [lat || 19.993982, lng || 73.790416],
        zoom: 6,
        layers: [
          L.tileLayer(MAP_URLS.ROAD_MAP, {
            attribution: "&copy; OpenStreetMap contributors",
          }),
        ],
      });
    }

    const map = mapRef.current;
    map.setView([lat, lng], 12);

    // Add user location marker
    const marker = L.marker([lat, lng], { icon: markerIcon }).addTo(map);
    marker.on("click", () => {
      map.flyTo([lat, lng], Math.min(map.getZoom() + 1, map.getMaxZoom()));
    });

    // Add pilot marker if available
    const completedStatus = status_history?.find(
      (status) => status.updated_status === STATUS.COMPLETED
    );
    if (completedStatus && completedStatus.pilot_lat && completedStatus.pilot_lng) {
      L.marker([completedStatus.pilot_lat, completedStatus.pilot_lng], {
        icon: PilotIcon,
      }).addTo(map);
    }

    return () => {
      map.remove();
      mapRef.current = null;
    };
  }, [lat, lng, status_history]);

  const switchBaseLayer = () => {
    const map = mapRef.current;
    const newLayer = activeBaseLayer === "satelite" ? MAP_URLS.ROAD_MAP : MAP_URLS.SATELITE;
    setActiveBaseLayer(activeBaseLayer === "satelite" ? "roadmap" : "satelite");

    map.eachLayer((layer) => {
      if (layer instanceof L.TileLayer) {
        map.removeLayer(layer);
      }
    });

    L.tileLayer(newLayer, { attribution: "&copy; OpenStreetMap contributors" }).addTo(map);
  };

  const toggleFullScreen = () => {
    if (!document.fullscreenElement) {
      mapContainerRef.current.requestFullscreen().catch((err) => {
        console.error(`Error enabling full-screen mode: ${err.message}`);
      });
    } else {
      document.exitFullscreen();
    }
  };

  return (
    <div style={{ width: "50%", }}>
      <div
        ref={mapContainerRef}
        id="map1"
        style={{
          position: "relative",
          zIndex: 1,
          right: 30,
          top:10,
          bottom: 20,
          width: "400px",
          height: "180px",
          padding: "5px",
          borderRadius: "8px",
        }}
      >
      {/* Switch Layer Button */}
      <div
        style={{
          border: "solid 1px rgb(102, 102, 102, 0.3)",
          height: "25px",
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          borderRadius: "5px",
          cursor: "pointer",
          left: 5,
          position:"absolute",
          zIndex:9999,
          bottom: 10,
          width:"70px"
        }}
        onClick={switchBaseLayer}
      >
        <img
          style={{ width: "100%", height: "25px", borderRadius: "4px" }}
          src={activeBaseLayer === "satelite" ? roadMapView : sateliteView}
          alt="Switch Map"
        />
      </div>

      {/* Fullscreen Button */}
      <div
        style={{
          position: "absolute",
          bottom:-15,
          right:20,
          height: "50px",
          zIndex: "999",
          cursor: "pointer",
        }}
      >
        <img
          src={isFullScreen ? collapseIcon : fullScreenIcon}
          onClick={toggleFullScreen}
          alt="Fullscreen Toggle"
          width={isFullScreen ? "25px" : "20px"}
          height={"25px"}
        />
      </div>

      </div>

    </div>
  );
}
